import { Button } from "antd";
import { Flag, Check } from "lucide-react";
import useReportError from "hooks/useReportError/useReportError";

/**
 * Drop-in button that reports an error as a support ticket.
 *
 * Props:
 *   error          — the Error object (optional, used in ErrorBoundary)
 *   componentStack — React component tree string (optional, from react-error-boundary)
 *   context        — free-text label for where the error came from e.g. "404 Page" (optional)
 */
function ReportErrorButton({ error, componentStack, context }) {
  const { reporting, reported, report } = useReportError();

  return (
    <Button
      icon={
        reported ? (
          <Check className="h-3.5 w-3.5" />
        ) : (
          <Flag className="h-3.5 w-3.5" />
        )
      }
      loading={reporting}
      disabled={reported}
      onClick={() => report({ error, componentStack, context })}
    >
      {reported ? "Reported" : "Report Issue"}
    </Button>
  );
}

export default ReportErrorButton;
